import PatientReferralDoughnut from './_PatientReferralDoughnut';

export default PatientReferralDoughnut;
